import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Tag } from 'ui'

import type { FirstPurchase as FirstPurchaseType } from 'typings'
import { messages } from './messages'

type FirstPurchaseProps = {
  firstPurchase: FirstPurchaseType | undefined
}

export function FirstPurchase(props: FirstPurchaseProps) {
  const { firstPurchase } = props
  const { $t } = useIntl()

  if (!firstPurchase) return null

  const { login } = firstPurchase

  return (
    <Tooltip text={$t(messages.firstPurchase.tooltip[login])}>
      <Tag>
        <FormattedMessage {...messages.firstPurchase.tag} />
      </Tag>
    </Tooltip>
  )
}
